document.addEventListener("DOMContentLoaded", function () {
  const pageUrl = encodeURIComponent(window.location.href);
  const pageTitle = encodeURIComponent(document.title);

  document.querySelectorAll(".social-share-buttons").forEach(group => {
    // Facebook
    group.querySelector(".share-facebook").href =
      `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`;

    // Twitter (X)
    group.querySelector(".share-twitter").href =
      `https://twitter.com/intent/tweet?url=${pageUrl}&text=${pageTitle}`;

    // Email
    group.querySelector(".share-email").href =
      `mailto:?subject=${pageTitle}&body=${pageUrl}`;

    // Copy URL
    group.querySelector(".copy-url").addEventListener("click", function () {
      navigator.clipboard.writeText(window.location.href).then(() => {
        alert("URL copied to clipboard!");
      }).catch(err => {
        console.error("Could not copy URL:", err);
      });
    });
  });
});


  class AtcButton extends HTMLElement {
  connectedCallback() {
    const cartType = this.dataset.cartType;
    const variantId = this.getAttribute('value');

    if (!variantId) return;

    this.addEventListener('click', (event) => {
      event.preventDefault();

      // Prepare data for Shopify AJAX API
      const formData = {
        items: [{
          id: variantId,
          quantity: 1
        }]
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(res => res.json())
        .then(data => {
          console.log('Added to cart:', data);

          if (cartType === 'drawer') {
            document.dispatchEvent(new CustomEvent("ajaxProduct:added", { bubbles: true }));
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(err => console.error('Error:', err));
    });
  }
}

customElements.define('atc-button', AtcButton);


// Discount copy and share 

document.querySelectorAll('.copyBtn').forEach((btn) => {
  btn.addEventListener('click', function () {
    const copyBox = btn.closest('.copy-box');
    const copyTextEl = copyBox.querySelector('.copyText');
    const originalText = copyTextEl.innerText;

    navigator.clipboard.writeText(originalText).then(() => {
      copyTextEl.innerText = "Copied!";
      setTimeout(() => {
        copyTextEl.innerText = originalText;
      }, 2000);
    });
  });
});

// Video swipper sldeir
document.addEventListener("DOMContentLoaded", () => {
    const videoSwiper = new Swiper(".videoSwiper", {
        slidesPerView: 1.4,
        loop: true,
        centeredSlides: true,
        spaceBetween: 30,
        loop: true,
        breakpoints: {
            768: { 
                slidesPerView: 3,
                centeredSlides: false,
                loop: false
            },
            1024: { 
                slidesPerView: 6,
                centeredSlides: false,
                loop: false
            }
        }
    });

    const slides = document.querySelectorAll(".video-slide");
    slides.forEach(slide => {
        const video = slide.querySelector("video");
        const btn = slide.querySelector(".play-btn");

        btn.addEventListener("click", () => {

            slides.forEach(otherSlide => {
                const oVid = otherSlide.querySelector("video");
                const oBtn = otherSlide.querySelector(".play-btn");

                if (oVid !== video) {
                    oVid.pause();
                    oBtn.style.display = "flex";
                }
            });

            video.play();
            btn.style.display = "none";
        });

        video.addEventListener("click", () => {
            video.pause();
            btn.style.display = "flex";
        });

        video.addEventListener("ended", () => {
            btn.style.display = "flex";
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const openButtons = document.querySelectorAll(".open-modal");

  openButtons.forEach(button => {
    button.addEventListener("click", function () {
      const modalId = this.getAttribute("data-block");
      const modal = document.getElementById(modalId);

      if (modal) {
        modal.style.display = "flex";
      }
    });
  });

  // Close button + overlay click
  const modals = document.querySelectorAll(".modal-overlay");

  modals.forEach(modal => {
    const closeBtn = modal.querySelector(".modal-close");

    // Close button clicked
    closeBtn.addEventListener("click", function () {
      modal.style.display = "none";
    });

    // Overlay clicked
    modal.addEventListener("click", function (e) {
      if (e.target === modal) {
        modal.style.display = "none";
      }
    });
  });

});

